export default {"src":"/_next/static/media/deployment.65ba92eb.svg","height":28,"width":27};